import { type FC, lazy } from "react"
import styled from "styled-components"

import Button from "~/components/Button"
import { componentBackgroundColor, componentBorderColor, lightTextColor } from "~/utilities/styles"

const NoMembershipsImage = lazy(() => import("./NoMembershipsImage"))

const NoMemberships: FC<{ onCreateTier: () => void }> = ({ onCreateTier }) => (
	<Container>
		<NoMembershipsImage className="text-primary w-48 max-w-full" />
		<Title>Tiers</Title>
		<Text>
			Academy membership is a way for your users to subscribe to you for a recurring fee, and you can choose what
			perks each tier will receive.
		</Text>
		<Button variant="primary" onClick={onCreateTier}>
			Create new tier
		</Button>
	</Container>
)

const Container = styled.div`
	background-color: ${componentBackgroundColor};
	border: 1px solid ${componentBorderColor};
	border-radius: 24px;
	padding: clamp(24px, 4vw, 40px);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`

const Title = styled.h2`
	font-weight: 600;
	font-size: 20px;
`

const Text = styled.p`
	color: ${lightTextColor};
	text-align: center;
	max-width: 500px;
`

export default NoMemberships
